<template>
  <div id="contents-data">
    <!-- ヘッダー -->
    <dd-header></dd-header>
    <!-- ローディングモーダル -->
    <dd-loading-modal ref="loadingModalRef" />
    <!-- 新規作成/編集モーダル -->
    <div class="modal" v-if="isOpenModal"  v-drag="{handle:'#modal-moving'}" style="position: fixed">
      <div class="modal-main">
        <div class="title-area" id="modal-moving">
          <h2 v-if="isNewModal">新規登録</h2>
          <h2 v-if="!isNewModal">編集</h2>
        </div>
        <div class="register_modal">
          <table>
            <tr v-if="!isNewModal">
              <td class="item">コンテンツID</td>
              <td>{{contentsData.contentsDataId}}</td>
            </tr>
            <tr>
              <td class="item">企業ID</td>
              <td><input type="number" v-model="contentsData.corpId"></td>
            </tr>
            <tr>
              <td class="item">登録コンテンツ</td>
              <td>
                <select v-model="contentsData.contentsType">
                  <option value="0"></option>
                  <option value="1">UM_CODE</option>
                  <option value="2">STYLE[KAGULL]</option>
                </select>
              </td>
            </tr>
            <tr>
              <td class="item">品番</td>
              <td><input type="text" v-model="contentsData.umCode"></td>
            </tr>
            <tr>
              <td class="item">キー番号</td>
              <td><input type="number" v-model="contentsData.code"></td>
            </tr>
            <tr>
              <td class="item">優先度</td>
              <td><input type="text" v-model="contentsData.contentsPriority"></td>
            </tr>
            <tr>
              <td class="item">説明文(短)</td>
              <td><input type="text" v-model="contentsData.contentsTextShort"></td>
            </tr>
            <tr>
              <td class="item">説明文(長)</td>
              <td><textarea type="text" rows="10" v-model="contentsData.contentsTextLong"></textarea></td>
            </tr>
            <tr>
              <td class="item">画像(大)</td>
              <td>
                <label class="file_upload main_btn" for="file_upload_big">
                  変更
                  <input type="file" id="file_upload_big" @change="fileChangeImgBig"/>
                </label>
                <img v-if="getContentsImg('big', 'contentsImgBig')" :src="getContentsImg('big', 'contentsImgBig')"
                  class="contents_data_img" width="100px" height="100px"/>
              </td>
            </tr>
            <tr>
              <td class="item">画像(中)</td>
              <td>
                <label class="file_upload main_btn" for="file_upload_mid">
                  変更
                  <input type="file" id="file_upload_mid" @change="fileChangeImgMid"/>
                </label>
                <img v-if="getContentsImg('mid', 'contentsImgMid')" :src="getContentsImg('mid', 'contentsImgMid')"
                  class="contents_data_img" width="100px" height="100px"/>
              </td>
            </tr>
            <tr>
              <td class="item">画像(小)</td>
              <td>
                <label class="file_upload main_btn" for="file_upload_small">
                  変更
                  <input type="file" id="file_upload_small" @change="fileChangeImgSmall"/>
                </label>
                <img v-if="getContentsImg('small', 'contentsImgSmall')" :src="getContentsImg('small', 'contentsImgSmall')"
                  class="contents_data_img" width="100px" height="100px"/>
              </td>
            </tr>
            <tr>
              <td class="item">施工写真1</td>
              <td>
                <label class="file_upload main_btn" for="file_upload_const1">
                  変更
                  <input type="file" id="file_upload_const1" @change="fileChangeImgConst1"/>
                </label>
                <img v-if="getContentsImg('const1', 'contentsImgConst1')" :src="getContentsImg('const1', 'contentsImgConst1')"
                  class="contents_data_img" width="100px" height="100px"/>
              </td>
            </tr>
            <tr>
              <td class="item">施工写真2</td>
              <td>
                <label class="file_upload main_btn" for="file_upload_const2">
                  変更
                  <input type="file" id="file_upload_const2" @change="fileChangeImgConst2"/>
                </label>
                <img v-if="getContentsImg('const2', 'contentsImgConst2')" :src="getContentsImg('const2', 'contentsImgConst2')"
                  class="contents_data_img" width="100px" height="100px"/>
              </td>
            </tr>
            <tr>
              <td class="item">施工写真3</td>
              <td>
                <label class="file_upload main_btn" for="file_upload_const3">
                  変更
                  <input type="file" id="file_upload_const3" @change="fileChangeImgConst3"/>
                </label>
                <img v-if="getContentsImg('const3', 'contentsImgConst3')" :src="getContentsImg('const3', 'contentsImgConst3')"
                  class="contents_data_img" width="100px" height="100px"/>
              </td>
            </tr>
            <tr>
              <td class="item">備考</td>
              <td><textarea type="text" rows="10" v-model="contentsData.contentsRemark"></textarea></td>
            </tr>
            <tr>
              <td class="item">削除フラグ</td>
              <td>
                なし<input type="radio" v-model="contentsData.delFlg" value="false">
                あり<input type="radio" v-model="contentsData.delFlg" value="true">
              </td>
            </tr>
          </table>
          <div class="error_area">
            <!-- エラーメッセージ -->
            <p class="error_message" v-for="(e, idx) in validateErrorMessages" :key="idx">
              <span v-if="idx !== 'CustomConstraint'">
                {{e}}
              </span>
            </p>
            <p class="error_message" v-for="(e, idx) in validateCustomErrorMessages" :key="idx">
              {{e}}
            </p>
          </div>
          <div class="modal_button">
            <button class="main_btn register_btn" v-if="isNewModal" @click="register">登録</button>
            <button class="main_btn" v-else @click="register">更新</button>
            <button class="main_btn close-btn" @click="closeModal">閉じる</button>
          </div>
        </div>
      </div>
    </div>
    <div id="container">
      <div id="content">
        <!-- 検索 -->
        <div class="condition">
          <input type="text" v-model="umCode" placeholder="品番">
          <input type="text" v-model="code" placeholder="キー番号">
          <button @click="search" type="button" class="main_btn">検索</button>
          <button @click="openNewModal" type="button" class="main_btn">新規登録</button>
        </div>
        <!-- 検索結果 -->
        <div class="result">
          <table>
            <thead>
              <th>コンテンツID</th>
              <th>企業ID</th>
              <th>登録コンテンツ</th>
              <th>品番</th>
              <th>キー番号</th>
              <th>優先度</th>
              <th>説明文(短)</th>
              <th>説明文(長)</th>
              <th>画像(大)</th>
              <th>画像(中)</th>
              <th>画像(小)</th>
              <th>施工写真1</th>
              <th>施工写真2</th>
              <th>施工写真3</th>
              <th>備考</th>
              <th>削除フラグ</th>
              <th>機能</th>
            </thead>
            <tbody>
              <tr v-for="(contentsData, index) in contentsDatas" :key="index">
                <td v-if="key !== 'contentsCount'" v-for="(value, key) in contentsData" :key="key">
                  <!-- 画像 -->
                  <img v-if="isImg(key) && getImg(index, key)" :src="getImg(index, key)" height="54px" width="54px">
                  <!-- 画像以外 -->
                  <span v-else-if="!isImg(key)">{{value}}</span>
                </td>
                <td>
                  <button class="main_btn" @click="openEditModal(index)">編集</button><br>
                  <button class="main_btn delete_btn" @click="deleteData(index)">削除</button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
    <dd-footer />
  </div>
</template>
<script>
import axios from 'axios'
import * as Api from '../utils/Api'
import * as App from '../utils/App'
import * as Calc from '../utils/Calc'
import {API_URL} from '../constants/App'
import {CONTENTS_TYPE} from '../constants/Type'
import Header from '../components/common/Header'
import Footer from '../components/common/Footer'
import LoadingModal from '../components/common/LoadingModal'

export default {
  name: 'ContentsData',
  components: {
    'dd-header': Header,
    'dd-footer': Footer,
    'dd-loading-modal': LoadingModal
  },
  data () {
    return {
      isOpenModal: false,
      isNewModal: false,
      maxFileSize: 0,
      umCode: '',
      code: '',
      // 検索結果
      contentsDatas: [],
      // 編集中の値
      contentsData: {},
      // 追加する画像データ
      contentsDataUploadFile: {
        big: null,
        mid: null,
        small: null,
        const1: null,
        const2: null,
        const3: null
      },
      errorMessage: { text: '' },
      validateErrorMessages: {},
      validateCustomErrorMessages: {}
    }
  },
  methods: {
    // *****************************************************************
    // 初期表示
    // *****************************************************************
    getMaxFileSize: function () {
      this.$refs.loadingModalRef.showModal(true)
      axios.get(API_URL.CONTENTS_DATA + '/getmaxfilesize'
      ).then(response => {
        if (response.data.errorMessage) {
          let modalData = {
            title: 'ファイルの最大サイズの取得に失敗しました。',
            messages: response.data.errorMessage.split(/\r?\n/g),
            messageType: 'error'
          }
          App.showModal(modalData)
        } else {
          this.maxFileSize = response.data.data
        }
      }).catch(error => {
        console.log(error)
        Api.handleError(error, this.errorMessage, this.fieldErrorMessages)
      }).finally(() => {
        this.$refs.loadingModalRef.showModal(false)
      })
    },
    init: function () {
      this.contentsData = {
        corpId: '',
        contentsType: '',
        umCode: '',
        code: '',
        contentsPriority: '',
        contentsTextShort: '',
        contentsTextLong: '',
        contentsImgBig: '',
        contentsImgMid: '',
        contentsImgSmall: '',
        contentsImgConst1: '',
        contentsImgConst2: '',
        contentsImgConst3: '',
        contentsRemark: '',
        delFlg: false
      }
      Object.keys(this.contentsDataUploadFile).forEach(k => {
        this.contentsDataUploadFile[k] = null
      })
    },
    // *****************************************************************
    // 検索/検索結果
    // *****************************************************************
    search: function () {
      this.$refs.loadingModalRef.showModal(true)
      this.resetErrorMessage()
      axios.get(API_URL.CONTENTS_DATA + '/get?umCode=' + this.umCode + '&code=' + this.code
      ).then(response => {
        if (response.data.errorMessage) {
          let modalData = {
            title: 'コンテンツデータの取得に失敗しました',
            messages: response.data.errorMessage.split(/\r?\n/g),
            messageType: 'error'
          }
          App.showModal(modalData)
        } else {
          this.contentsDatas = response.data.data
        }
      }).catch(error => {
        console.log(error)
        // Api.handleError(error, this.errorMessage, this.fieldErrorMessages)
      }).finally(() => {
        this.$refs.loadingModalRef.showModal(false)
      })
    },
    isImg: function (key) {
      return ['contentsImgBig', 'contentsImgMid', 'contentsImgSmall', 'contentsImgConst1', 'contentsImgConst2', 'contentsImgConst3'].includes(key)
    },
    getImg: function (index, key) {
      let contentsData = this.contentsDatas[index]
      if (contentsData != null && contentsData[key]) {
        return App.getContentsResource(contentsData.corpId + '/' + contentsData[key])
      }
      return ''
    },
    // *****************************************************************
    // 新規追加/編集/削除
    // *****************************************************************
    fileChangeImgBig: function (event) {
      this.contentsDataUploadFile.big = event.target.files[0]
    },
    fileChangeImgMid: function (event) {
      this.contentsDataUploadFile.mid = event.target.files[0]
    },
    fileChangeImgSmall: function (event) {
      this.contentsDataUploadFile.small = event.target.files[0]
    },
    fileChangeImgConst1: function (event) {
      this.contentsDataUploadFile.const1 = event.target.files[0]
    },
    fileChangeImgConst2: function (event) {
      this.contentsDataUploadFile.const2 = event.target.files[0]
    },
    fileChangeImgConst3: function (event) {
      this.contentsDataUploadFile.const3 = event.target.files[0]
    },
    register: function () {
      this.resetErrorMessage()
      if (!this.validation()) return

      let contentsDataForm = {
        contentsDataId: this.contentsData.contentsDataId,
        corpId: Number(this.contentsData.corpId),
        contentsType: Number(this.contentsData.contentsType),
        umCode: this.contentsData.umCode,
        code: Number(this.contentsData.code),
        contentsPriority: this.contentsData.contentsPriority,
        contentsTextShort: this.contentsData.contentsTextShort,
        contentsTextLong: this.contentsData.contentsTextLong,
        contentsImgBig: this.contentsData.contentsImgBig,
        contentsImgMid: this.contentsData.contentsImgMid,
        contentsImgSmall: this.contentsData.contentsImgSmall,
        contentsImgConst1: this.contentsData.contentsImgConst1,
        contentsImgConst2: this.contentsData.contentsImgConst2,
        contentsImgConst3: this.contentsData.contentsImgConst3,
        contentsRemark: this.contentsData.contentsRemark,
        delFlg: this.contentsData.delFlg
      }

      let payload = new FormData()
      if (this.contentsDataUploadFile.big != null) {
        payload.append('contentsImgBig', new Blob([this.contentsDataUploadFile.big],
          {type: this.contentsDataUploadFile.big.type}), this.contentsDataUploadFile.big.name)
      }
      if (this.contentsDataUploadFile.mid != null) {
        payload.append('contentsImgMid', new Blob([this.contentsDataUploadFile.mid],
          {type: this.contentsDataUploadFile.mid.type}), this.contentsDataUploadFile.mid.name)
      }
      if (this.contentsDataUploadFile.small != null) {
        payload.append('contentsImgSmall', new Blob([this.contentsDataUploadFile.small],
          {type: this.contentsDataUploadFile.small.type}), this.contentsDataUploadFile.small.name)
      }
      if (this.contentsDataUploadFile.const1 != null) {
        payload.append('contentsImgConst1', new Blob([this.contentsDataUploadFile.const1],
          {type: this.contentsDataUploadFile.const1.type}), this.contentsDataUploadFile.const1.name)
      }
      if (this.contentsDataUploadFile.const2 != null) {
        payload.append('contentsImgConst2', new Blob([this.contentsDataUploadFile.const2],
          {type: this.contentsDataUploadFile.const2.type}), this.contentsDataUploadFile.const2.name)
      }
      if (this.contentsDataUploadFile.const3 != null) {
        payload.append('contentsImgConst3', new Blob([this.contentsDataUploadFile.const3],
          {type: this.contentsDataUploadFile.const3.type}), this.contentsDataUploadFile.const3.name)
      }
      payload.append('contentsDataForm', JSON.stringify(contentsDataForm))

      axios.post(API_URL.CONTENTS_DATA + '/register', payload)
        .then(response => {
          this.$refs.loadingModalRef.showModal(false)
          if (response.data.errorMessage) {
            if (Object.keys(response.data.validationErrors).length > 0) {
              this.errorMessage.text = response.data.errorMessage
            } else {
              App.showModal({
                title: 'エラー',
                messages: [response.data.errorMessage],
                messageType: 'error'
              })
            }
          } else {
            this.closeModal()
            App.showModal({
              messages: ['保存しました。'],
              onOk: () => {
                this.search()
              }
            })
          }
        }).catch(error => {
          this.$refs.loadingModalRef.showModal(false)
          this.validateErrorMessages = {}
          Api.handleError(error, this.errorMessage, this.validateErrorMessages)
          this.setValidationCustomError(error)
        })
    },
    deleteData: function (index) {
      let contentsDataId = this.contentsDatas[index].contentsDataId
      if (!window.confirm('コンテンツID：' + contentsDataId + 'を削除しますか？')) return
      this.$refs.loadingModalRef.showModal(true)
      axios.get(API_URL.CONTENTS_DATA + '/delete?contentsDataId=' + contentsDataId
      ).then(response => {
        if (response.data.errorMessage) {
          let modalData = {
            title: '削除に失敗しました。',
            messages: response.data.errorMessage.split(/\r?\n/g),
            messageType: 'error'
          }
          App.showModal(modalData)
        } else {
          App.showModal({
            messages: ['削除しました。'],
            onOk: () => {
              this.search()
            }
          })
        }
      }).catch(error => {
        console.log(error)
        Api.handleError(error, this.errorMessage, this.fieldErrorMessages)
      }).finally(() => {
        this.$refs.loadingModalRef.showModal(false)
      })
    },
    // *****************************************************************
    // バリデーション
    // *****************************************************************
    validation: function () {
      let valid = true

      // 入力チェック
      switch (Number(this.contentsData.contentsType)) {
        case CONTENTS_TYPE.UM_CODE:
          if (!this.contentsData.umCode || this.contentsData.umCode == null) {
            this.$set(this.validateErrorMessages, 'umCode', '品番を入力してください。')
            valid = false
          }
          break
        case CONTENTS_TYPE.STYLE:
          if (!this.contentsData.code || this.contentsData.code == null) {
            this.$set(this.validateErrorMessages, 'code', 'キー番号を入力してください。')
            valid = false
          }
          break
        default:
          this.$set(this.validateErrorMessages, 'contentsType', '登録コンテンツを選択してください。')
          valid = false
          break
      }
      if (!this.contentsData.corpId || this.contentsData.corpId == null) {
        this.$set(this.validateErrorMessages, 'corpId', '企業IDを入力してください。')
        valid = false
      }

      // コンテンツデータの画像のアップロードの合計ファイルサイズの上限チェック
      let filesSize = 0
      Object.keys(this.contentsDataUploadFile).forEach(k => {
        let file = this.contentsDataUploadFile[k]
        if (file != null) filesSize += file.size
      })
      if (filesSize > this.maxFileSize) {
        this.$set(this.validateErrorMessages, 'maxFileSize', 'アップロードする画像のサイズの合計が上限より' + Calc.convertByte(filesSize - this.maxFileSize) + '大きいです。')
        valid = false
      }

      return valid
    },
    setValidationError: function (error) {
      this.validateErrorMessages = {}
      if (error.response.data.validationErrors == null) return
      let validationErrors = error.response.data.validationErrors
      if (validationErrors.CustomConstraint == null) return
      this.validateErrorMessages = validationErrors.CustomConstraint
    },
    setValidationCustomError: function (error) {
      this.validateCustomErrorMessages = {}
      if (error.response.data.validationErrors == null) return
      let validationErrors = error.response.data.validationErrors
      if (validationErrors.CustomConstraint == null) return
      this.validateCustomErrorMessages = validationErrors.CustomConstraint
    },
    resetErrorMessage: function () {
      this.errorMessage = { text: '' }
      this.validateErrorMessages = {}
      this.validateCustomErrorMessages = {}
    },
    // *****************************************************************
    // その他
    // *****************************************************************
    openNewModal: function () {
      this.isOpenModal = true
      this.isNewModal = true
    },
    openEditModal: function (index) {
      this.contentsData = Object.assign({}, this.contentsDatas[index])
      this.isOpenModal = true
    },
    closeModal: function () {
      this.isOpenModal = false
      this.isNewModal = false
      this.init()
      this.resetErrorMessage()
    },
    getContentsImg: function (key, key2) {
      if (this.contentsDataUploadFile[key] != null) {
        return URL.createObjectURL(this.contentsDataUploadFile[key])
      }
      if (this.contentsData[key2]) {
        return App.getContentsResource(this.contentsData.corpId + '/' + this.contentsData[key2])
      }
      return ''
    },
    totalSize: function () {
      return this.files.reduce((p, x) => p + x.size, 0)
    },
    convertByte: function (size) {
      let convertedByte = Calc.convertByte(size)
      return convertedByte != null ? convertedByte : null
    }
  },
  computed: {
  },
  mounted: function () {
    this.getMaxFileSize()
    this.init()
  }
}
</script>
<style src="../css/style.scss" lang="scss" scoped></style>
<style lang="scss" scoped>
#contents-data {
  background: #eee;
  height: 100%;
  min-width: 1000px;
  min-height: 680px;
}
#container {
  padding: 20px;
  height: calc(100% - 137px);
}
#content {
  height: 100%;
}
.condition {
  margin-bottom: 10px;
}
.result {
  overflow: scroll;
  width: 100%;
  height: calc(100% - 45px);
  table {
    width: 1800px;
    th {
      background: #666;
      color: #FFF;
    }
    td {
      white-space: nowrap;
      overflow: scroll;
      vertical-align: top;
    }
  }
}
// *****************************************************************
// モーダル
// *****************************************************************
.modal {
  .modal-main {
    min-width: 500px;
    min-height: 600px;
    .register_modal {
      .item {
        background: #666;
        color: white;
        width: 100px;
        vertical-align: top;
      }
      .modal_button {
        margin-top: 10px;
        text-align: center;
      }
      input[type="text"] {
        width: 90%;
      }
      textarea {
        width: 90%;
      }
      input[type="file"] {
        display:none;
      }
      .contents_data_img {
        vertical-align: middle;
      }
    }
  }
}
.error_area {
  margin-top: 10px;
}
</style>



// WEBPACK FOOTER //
// src/main/js/pages/ContentsData.vue